import { z } from 'zod'

/**
 * Whether a client is a business or a household. Mirrors `ClientType` in
 * prisma/schema.prisma.
 *
 * This is a single field rather than two separate tables on purpose: the two
 * kinds differ in how they are *validated and presented* (a company name and
 * several contacts vs. a person's name and usually one), not in what they
 * relate to. Both have contacts, sites, and proposals, so splitting them would
 * force every downstream table into two nullable foreign keys and every list
 * query into a union.
 */
export const CLIENT_TYPES = ['COMMERCIAL', 'RESIDENTIAL'] as const

export const clientTypeSchema = z.enum(CLIENT_TYPES)

export type ClientType = z.infer<typeof clientTypeSchema>

export const CLIENT_TYPE_LABELS: Record<ClientType, string> = {
  COMMERCIAL: 'Commercial',
  RESIDENTIAL: 'Residential',
}
